import React from 'react';
import { Box, Button, IconButton, Typography, styled } from '@mui/material';
import { useAuthContext } from '@components/auth';
import { Launch } from '@mui/icons-material';
import theme from '@/theme';

const MuiToken = styled('div')(({ theme }) => ({
  position: 'relative',
  padding: theme.spacing(2),
  backgroundColor: theme.palette.grey[900],
  color: theme.palette.grey[200],
  borderRadius: theme.spacing(1),
  wordWrap: 'break-word',
  wordBreak: 'break-all',
  fontSize: '0.875rem',
  marginBottom: theme.spacing(3),
}));

const CopyBtn = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  right: theme.spacing(1),
  top: theme.spacing(1),
  color: theme.palette.grey[900],
  backgroundColor: theme.palette.grey[500],
  borderRadius: theme.spacing(0.5),
  boxShadow: theme.shadows[1],

  '& .MuiTypography-root': {
    fontSize: '0.75rem',
  },

  '&:hover': {
    backgroundColor: theme.palette.grey[600],
  },
}));

type TokenProps = {
  token: string;
};

const Token: React.FC<TokenProps> = ({ token }) => {
  const [url, setUrl] = React.useState('');
  const [docUrl, setDocUrl] = React.useState('');

  const { user } = useAuthContext();

  React.useEffect(() => {
    if (import.meta.env.VITE_SITE === 'Paybilt') {
      setUrl('https://dashboard.paybilt.com');
      setDocUrl('https://docs.paybilt.com/');
    } else {
      setUrl('https://dashboard.payper.ca');
      setDocUrl('https://docs.payper.ca/');
    }

    if (user.redirect && user.redirect !== '') {
      if (import.meta.env.VITE_SITE === 'Paybilt') {
        setUrl(
          `https://pay.paybilt.com/config/login${user.redirect}&token=${token}`
        );
      } else {
        setUrl(
          `https://pay.payper.ca/config/login${user.redirect}&token=${token}`
        );
      }
    } else {
      setUrl('https://apps.shopify.com/interac-e-transfer');
    }
  }, []);

  return (
    <Box mt={3}>
      <Typography variant="body2" mb={4}>
        Thank you for registering. Someone from our team will reach out to you
        with next steps.
      </Typography>

      {/* <MuiToken
        // click to select all
        onClick={(e) => {
          const selection = window.getSelection();
          const range = document.createRange();
          range.selectNodeContents(e.currentTarget);
          selection?.removeAllRanges();
          selection?.addRange(range);
        }}
      >
        {token}

        <CopyBtn
          size="small"
          onClick={() => navigator.clipboard.writeText(token || '')}
        >
          <Typography variant="body2" color="textSecondary">
            Copy
          </Typography>
        </CopyBtn>
      </MuiToken> */}

      <Typography variant="h6" gutterBottom>
        Getting Started
      </Typography>
      <Button size="small" sx={{ px: 0 }} href={url} target="_blank">
        Shopify installation page <Launch fontSize="small" />
      </Button>
      <br />
      <Button size="small" sx={{ px: 0 }} href={docUrl} target="_blank">
        {import.meta.env?.VITE_SITE} documentation <Launch fontSize="small" />
      </Button>
    </Box>
  );
};

export default Token;
